import React from 'react'

const site = JSON.parse(localStorage.getItem('site'))
const acc = JSON.parse(localStorage.getItem('acc'))

import { ReactComponent as OperationDebtors } from '../assets/svg/Header/OperationDebtors.svg'
import { ReactComponent as OperationContacts } from '../assets/svg/Header/HeaderPeople.svg'
import { ReactComponent as HeaderMessages } from '../assets/svg/Header/HeaderMessages.svg'

export const contacts = [
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/contacts',
    name: 'Contacts',
    icon: (
      <OperationContacts width={'30px'} height={'30px'} />
    ),
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.facturas, // Права теперь проверяются динамически
    link: '/admin/messages',
    name: `Messages`,
    icon: (
      <HeaderMessages width={'30px'} height={'30px'} />
    ),
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.juise,
    link: '/admin/meetings',
    name: `Daily Meetings`,
    icon: (
      <OperationDebtors width={'30px'} height={'30px'} />
    ),
    enabled: true,
    disabled: false,
  },
]
